import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });
export const token = () => localStorage.getItem("cs_token") || "";

api.interceptors.request.use((c) => {
  const t = token();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const fileUrl = (path, w = 0) => {
  if (!path) return "";
  if (path.startsWith("asset:")) return `${API}/assets/${path.slice(6)}`;
  return `${API}/files/${path}?auth=${token()}${w ? `&w=${w}` : ""}`;
};

export const authed = (p) => `${API}${p}${p.includes("?") ? "&" : "?"}auth=${token()}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
